import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Layout from '../../components/Layout'
import { CHANGE_PRODUCTS_PAGE } from '../../store/types'
import PagnationComponent from '../../components/PagnationComponent'
import { Button, Container, Typography } from '@mui/material'
import { roleListId, roleType } from '../../config/roleList'
import { checkUserRole } from '../../common/checkUserRole'
import { getAllProducts } from '../../store/actions/productAction'
import ProductInfos from '../../components/product/ProductInfo'
import SearchProduct from '../../components/product/SearchProduct'

const Products = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { products, pages, page, count, keyword } = useSelector(
        (state) => state.product
    )
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)

    const pageNumber = page || 1
    useEffect(() => {
        dispatch(getAllProducts(keyword, pageNumber))
    }, [dispatch, keyword, pageNumber])

    const changePage = useCallback(
        (page) => {
            dispatch({ type: CHANGE_PRODUCTS_PAGE, payload: page })
        },
        [dispatch]
    )
    return (
        <Layout>
            <Container>
                <Button
                    color="info"
                    variant="outlined"
                    onClick={() =>
                        checkUserRole(
                            userInfo,
                            roleList,
                            roleListId.PRODUCT,
                            roleType.CREATE
                        )
                            ? navigate(`/addproduct`)
                            : alert('Not Permit User')
                    }
                >
                    Add New Product
                </Button>
                <SearchProduct displayKeyword={keyword} />
                <Typography
                    variant="body2"
                    gutterBottom
                    style={{ paddingBottom: '10px', paddingTop: '10px' }}
                >
                    Count: {count}
                </Typography>
                {products && <ProductInfos products={products} />}
                <PagnationComponent
                    page={pageNumber}
                    pages={pages}
                    func={changePage}
                />
            </Container>
        </Layout>
    )
}

export default Products
